class NfeService extends EficienciaFiscalAbstractService

  configure: (configs, injector) ->
    configs.url = '/nfes'

    super(configs, injector)

  freteManual: (nfe, channel, callback) ->
    @modal.open({
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      templateUrl: "#{@pathService.getViewUrl()}eficiencia-fiscal/view/dashboard/consulta-nfe/nfe/informar-frete-modal.html",
      controller: 'nfeInformarFreteModalController as ctrl',
      resolve: {
        nfe: -> nfe
        channel: -> channel
      }
    }).result.then((retorno) ->
      callback(retorno) if callback
    )

angular.module('eficienciaFiscalModule').service('nfeService', NfeService)


class NfeInformarFreteModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', '$filter', 'nfeService', 'nfe', 'channel' ]

  constructor: ($injector, @modalInstance, @filter, @nfeService, @nfe, @channel) ->
    super($injector)
    @submitTracker = @promiseTracker()

  salvar: (form, valor, valorFreteIcms) ->
    if form.$valid
      Confirm.warning("Atenção", """
        Deseja informar que o valor do #{if @nfe.valor_frete > 0 then 'redespacho' else 'CT-e'} vinculado à NF-e
        <strong>#{@nfe.numero}</strong> é igual a <strong>#{@filter("currency")(valor)}</strong>
        e o valor do ICMS referente ao frete é de <strong>#{@filter("currency")(valorFreteIcms)}</strong>?
        Deste modo, o valor total do frete desta NF-e será de: <strong>#{@filter("currency")(parseFloat(valor) + parseFloat(@nfe.valor_frete))}</strong>.
      """, {
        'Eu desejo': =>
          socket.push(@channel, "informar_frete_manual", nfe: @nfe.id, valor_frete_manual: valor, valor_frete_icms: valorFreteIcms)
            .then(=>
              Alert.success("Valor do CT-e e ICMS informados manualmente com sucesso.", "Sucesso!")
              @modalInstance.close(new Retorno(true, null, valor_frete_manual: valor, valorFreteIcms: valorFreteIcms))
            )
            .catch(=>
              Alert.warning("Não foi possível informar o valor do CT-e manualmente.", "Ocorreu um erro.")
            )
        'Eu não desejo': null
      })

angular.module('eficienciaFiscalModule').controller('nfeInformarFreteModalController', NfeInformarFreteModalController)
